// services/api.js
import axios from "axios";
import { REACT_APP_API_BACKEND } from "../data/data";

let keycloakInstance = null;

export const setKeycloak = (keycloak) => {
  keycloakInstance = keycloak;
};

const api = axios.create({
  baseURL: REACT_APP_API_BACKEND,
});

// REQUEST INTERCEPTOR
api.interceptors.request.use(
  async (config) => {
    if (keycloakInstance?.token) {
      config.headers.Authorization = `Bearer ${keycloakInstance.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// RESPONSE INTERCEPTOR (REFRESH AUTOMÁTICO)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      keycloakInstance
    ) {
      originalRequest._retry = true;

      try {
        // renova se faltar menos de 30s
        await keycloakInstance.updateToken(30);

        originalRequest.headers.Authorization =
          `Bearer ${keycloakInstance.token}`;

        return api(originalRequest);
      } catch (err) {
        keycloakInstance.logout();
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default api;